package org.hs_soft.runmynesto.data.api_datasource.options.restaurant_manager

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.encodeToJsonElement
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient

import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.delete_floor.DeleteRestaurantFloorModel
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.delete_furniture.DeleteFurnitureModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.DeleteFloorRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.restaurant_manager.DeleteFurnitureRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

import org.hs_soft.runmynesto.domain.config.Errors


class DeleteFurnitureRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): DeleteFurnitureRepository
{
    override suspend fun deleteFloor(furnitureId: String): DeleteFurnitureModel {

        val abortController = requestManager.createController()
        val furnituresIds= listOf<String>(furnitureId)

        val graphQLQuery = buildJsonObject {
            put("query", """
              mutation deleteFurniture(${'$'}ids: [ID]!) {
                  cashAssist {
                    deleteFurniture(ids:${'$'}ids)
                    __typename
                  }
                }


            """.trimIndent())

            putJsonObject("variables") {
                put("ids",Json.encodeToJsonElement(furnituresIds as List<String>))
            }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)

        }


    }


}